import pubgWeeklyCongrats from '../static/vid/Bundles/weekly_pubg_congrats.webm';
import pubgWeeklySplash from '../static/vid/Bundles/weekly_pubg_splash.webm';
import pubgWeeklyExtremeCongrats from '../static/vid/Bundles/weekly_extreme_pubg_congrats.webm';
import pubgWeeklyExtremeSplash from '../static/vid/Bundles/weekly_extreme_pubg_splash.webm';
import pubgMonthlySplash from '../static/vid/Bundles/monthly_pubg_splash.mp4';
import pubgMonthlyCongrats from '../static/vid/Bundles/monthly_pubg_congrats.mp4';
import ffWeeklyCongrats from '../static/vid/Bundles/weekly_freefire_congrats.webm';
import ffWeeklySplash from '../static/vid/Bundles/weekly_freefire_splash.webm';
import ffMonthlyCongrats from '../static/vid/Bundles/monthly_freefire_congrats.webm';
import ffMonthlySplash from '../static/vid/Bundles/monthly_freefire_splash.mp4';
import pubgClaimVideo from '../static/vid/Bundles/reward_claim_pubg.webm';
import pubgMonthlyClaimVideo from '../static/vid/Bundles/reward_claim_pubg_monthly.mp4';
import ffClaimVideo from '../static/vid/Bundles/reward_claim_freefire.webm';
import pubgRewardImage from '../static/img/Rewards/pubgReward.jpg';
import freefireRewardImage from '../static/img/Rewards/freefireReward.jpg';
import jazzLogo from '../static/img/jazz.png';

export const BUNDLE_CODE_KEY = 'bundleCode';
export const BUNDLE_DATA_KEY = 'bundleData';

const PUBG_THEME = {
  accent: '#00E5FF',
  accentDark: '#7FF0FF',
  accentText: '#04222B',
  glow: 'rgba(0, 229, 255, 0.35)',
  soft: 'rgba(0, 229, 255, 0.10)',
  page: '#070B1E',
  topGradient: 'linear-gradient(180deg, rgba(0, 229, 255, 0.11) 0%, rgba(0, 229, 255, 0) 100%)',
  topGradientHeight: '140px',
  card: '#FFFFFF0B',
  cardBorder: '#FFFFFF1A',
  rewardBorder: '#00E5FF66',
  pill: 'linear-gradient(90deg, #7FF0FF 0%, #00E5FF 100%)',
  pillText: '#04222B',
  // challengeStatus 1 - submitted, awaiting review
  cardPendingBorder: '#00E5FF',
  // challengeStatus 2 - accepted
  cardCompleted: '#0A2416',
  cardCompletedBorder: 'rgba(0, 230, 118, 0.45)',
  pillCompleted: '#00E676',
  pillCompletedText: '#04220F',
  completedText: '#00E676',
  splashButton: 'linear-gradient(90deg, #7FF0FF 0%, #00E5FF 100%)',
  splashButtonGlow: '0px 0px 31.2px -5.2px #00E5FF',
  splashButtonText: '#04222B',
  splashBackdrop: 'linear-gradient(180deg, rgba(13, 21, 58, 0) 0%, #0D153A 35.55%, #0D153A 100%)',
  // Task submission sheet
  modalBg: '#141824',
  modalChallengeCard: 'linear-gradient(180deg, #1B2233 0%, #151A28 100%)',
  modalRewardBox: 'radial-gradient(50% 50% at 50% 50%, rgba(0, 229, 255, 0) 0%, rgba(0, 137, 153, 0) 100%)',
  modalRewardBorder: '#00E5FF73',
  modalRewardGlow: '0px 0px 20px -10px #00E5FFBF',
  modalPanel: '#FFFFFF09',
};

const FREEFIRE_THEME = {
  ...PUBG_THEME,
  accent: '#9EFF00',
  accentDark: '#C9FF6E',
  accentText: '#132200',
  glow: 'rgba(158, 255, 0, 0.35)',
  soft: 'rgba(158, 255, 0, 0.10)',
  page: '#050A12',
  topGradient: 'linear-gradient(180deg, rgba(158, 255, 0, 0.11) 0%, rgba(158, 255, 0, 0) 100%)',
  topGradientHeight: '140px',
  card: '#0C1622',
  rewardBorder: '#9EFF0066',
  pill: 'linear-gradient(90deg, #C9FF6E 0%, #9EFF00 100%)',
  pillText: '#132200',
  cardPendingBorder: '#9EFF00',
  splashButton: 'linear-gradient(90deg, #C9FF6E 0%, #9EFF00 100%)',
  splashButtonGlow: '0px 0px 31.2px -5.2px #9EFF00',
  splashButtonText: '#132200',
  splashBackdrop: 'linear-gradient(180deg, rgba(1, 9, 13, 0) 0%, #010809 40%, #010809 100%)',
  modalRewardBox: 'radial-gradient(50% 50% at 50% 50%, rgba(158, 255, 0, 0) 0%, rgba(99, 153, 0, 0) 100%)',
  modalRewardBorder: '#9EFF0073',
  modalRewardGlow: '0px 0px 20px -10px #9EFF00BF',
};

const PUBG_CLAIM = {
  reward: '30 UC',
  heroImage: pubgRewardImage,
  heroAlt: 'PUBG Mobile',
  heroSubtitle: 'Claim your exclusive UC reward',
  playerIdLabel: 'PUBG ID',
  playerIdField: 'pubgId',
  playerIdHint: 'Find this in PUBG Mobile → Profile',
  claimCta: 'CLAIM MY UC →',
  processingLine: 'Your UC is being processed.',
  video: pubgClaimVideo,
};

const FREEFIRE_CLAIM = {
  reward: '70 Free Fire Diamonds',
  heroImage: freefireRewardImage,
  heroAlt: 'Free Fire',
  heroSubtitle: 'Claim your exclusive diamonds reward',
  playerIdLabel: 'FREE FIRE ID',
  playerIdField: 'freefireId',
  playerIdHint: 'Find this in Free Fire → Profile',
  claimCta: 'CLAIM MY DIAMONDS →',
  processingLine: 'Your Free Fire Diamonds are being processed.',
  video: ffClaimVideo,
};

// pubm1 - no tasks, straight to the claim page
const PUBG_MONTHLY_CLAIM = {
  ...PUBG_CLAIM,
  reward: '60 UC',
  video: pubgMonthlyClaimVideo,
};

export const DEFAULT_CLAIM = { ...FREEFIRE_CLAIM, video: null };

export const BUNDLES = {
  ffw7: {
    code: 'ffw7',
    game: 'FREE FIRE',
    missions: 'WEEKLY MISSIONS',
    theme: FREEFIRE_THEME,
    claim: FREEFIRE_CLAIM,
    logo: jazzLogo,
    congratsVideo: ffWeeklyCongrats,
    splashVideo: ffWeeklySplash,
    splashCta: 'SEE MY MISSIONS →',
  },
  ffm1: {
    code: 'ffm1',
    game: 'FREE FIRE',
    missions: 'MONTHLY MISSIONS',
    theme: FREEFIRE_THEME,
    claim: FREEFIRE_CLAIM,
    logo: jazzLogo,
    congratsVideo: ffMonthlyCongrats,
    splashVideo: ffMonthlySplash,
    splashCta: 'SEE MY MISSIONS →',
  },
  pubw7: {
    code: 'pubw7',
    game: 'PUBG MOBILE',
    missions: 'WEEKLY MISSIONS',
    theme: PUBG_THEME,
    claim: PUBG_CLAIM,
    logo: jazzLogo,
    congratsVideo: pubgWeeklyCongrats,
    splashVideo: pubgWeeklySplash,
    splashCta: 'SEE MY MISSIONS →',
    taskTitle: 'PUBG UCS TASK',
  },
  pubw7e: {
    code: 'pubw7e',
    game: 'PUBG MOBILE',
    missions: 'WEEKLY EXTREME MISSIONS',
    theme: PUBG_THEME,
    claim: PUBG_CLAIM,
    logo: jazzLogo,
    congratsVideo: pubgWeeklyExtremeCongrats,
    splashVideo: pubgWeeklyExtremeSplash,
    splashCta: 'SEE MY MISSIONS →',
    taskTitle: 'PUBG UCS TASK',
  },
  pubm1: {
    code: 'pubm1',
    game: 'PUBG MOBILE',
    missions: 'MONTHLY REWARD',
    theme: PUBG_THEME,
    claim: PUBG_MONTHLY_CLAIM,
    logo: jazzLogo, 
    congratsVideo: pubgMonthlyCongrats,
    splashVideo: pubgMonthlySplash,
  },
};

export const BUNDLE_CODES = Object.keys(BUNDLES);

export const isBundleCode = (value) => !!value && Object.prototype.hasOwnProperty.call(BUNDLES, value);

export const getBundle = (code) => (isBundleCode(code) ? BUNDLES[code] : null);

export const resolveBundleCode = (...candidates) => candidates.find(isBundleCode) || null;

export const CHALLENGE_STATUS = {
  NOT_STARTED: 0,
  PENDING: 1,
  ACCEPTED: 2,
  REJECTED: 3,
};

export const isTaskActionable = (task) =>
  Number(task?.challengeStatus) === CHALLENGE_STATUS.NOT_STARTED ||
  Number(task?.challengeStatus) === CHALLENGE_STATUS.REJECTED;

export const summariseTasks = (tasks = []) => {
  const total = tasks.length;
  const completed = tasks.filter(
    task => Number(task.challengeStatus) === CHALLENGE_STATUS.ACCEPTED
  ).length;

  const creditsTotal = tasks.reduce((sum, task) => sum + (Number(task.challengePrize) || 0), 0);
  const creditsEarned = tasks.reduce(
    (sum, task) =>
      Number(task.challengeStatus) === CHALLENGE_STATUS.ACCEPTED
        ? sum + (Number(task.challengePrize) || 0)
        : sum,
    0
  );

  return {
    total,
    completed,
    creditsTotal,
    creditsEarned,
    percent: total > 0 ? Math.round((completed / total) * 100) : 0,
    allCompleted: total > 0 && completed === total,
  };
};

export const getStoredBundleCode = () => sessionStorage.getItem(BUNDLE_CODE_KEY);

export const resolveTaskBundleAccess = (routeState) => {
  const code = routeState?.bundleCode || getStoredBundleCode();
  if (!isBundleCode(code)) return null;

  const payload = routeState?.bundle || readStoredBundleResult(code);
  if (!payload?.success || payload.mode !== 'task') return null;

  return code;
};

const splashSeenKey = (bundleCode) => `bundleSplashSeen:${bundleCode}`;

export const hasSeenSplash = (bundleCode) => {
  try {
    return sessionStorage.getItem(splashSeenKey(bundleCode)) === 'true';
  } catch {
    return false;
  }
};

export const markSplashSeen = (bundleCode) => {
  try {
    sessionStorage.setItem(splashSeenKey(bundleCode), 'true');
  } catch {
  }
};

export const storeBundleResult = (bundleCode, data) => {
  sessionStorage.setItem(BUNDLE_CODE_KEY, bundleCode);
  sessionStorage.setItem(BUNDLE_DATA_KEY, JSON.stringify(data));
};

export const getStoredRedemptionId = () => {
  try {
    const code = getStoredBundleCode();
    if (!code) return null;
    return readStoredBundleResult(code)?.redemption_id || null;
  } catch {
    return null;
  }
};

export const getStoredBundleReward = () => {
  try {
    const code = getStoredBundleCode();
    if (!code) return null;
    return readStoredBundleResult(code)?.reward || null;
  } catch {
    return null;
  }
};

export const readStoredBundleResult = (bundleCode) => {
  try {
    if (getStoredBundleCode() !== bundleCode) return null;
    return JSON.parse(sessionStorage.getItem(BUNDLE_DATA_KEY));
  } catch {
    return null;
  }
};